import { FunctionComponent } from "react";


interface IYouTubePlayerProps {
    url: string;
    title: string;
    styles ?: string;
}

const YouTubePlayer: FunctionComponent<IYouTubePlayerProps> = ({ url, title, styles }) => (
  <div className={`w-[70%] h-[920px] ${styles || ""} flex justify-center items-center`}>
    <iframe
      src={url}
      title={title || "YouTube video player"}
      className="w-full h-full"
      allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowFullScreen
    />
  </div>
);

export default YouTubePlayer;